export default "__VITE_ASSET__DY$JWSyg__"